<script>
/*
<template functional>
  <div>
    <small v-if="props.model.$error" class="text-sm text-danger">{{props.model.$error}}</small>
  </div>
</template>

*/
export default {
  name: 'w-error',
  props: ['model', 'id'],
  render(h, context) {
    /* if (context.sectionName === undefined) {
      context.sectionName = null;
      let parent = context.parent;
      while (parent) {
        if (parent.sectionName) {
          context.sectionName = parent.sectionName;
          break;
        }
        parent = parent.$parent;
      }
    }
    context.props.model.$formSection = context.sectionName;
    */
    const err = this.model.$error;

    if (this.model.$form.testPath) {
      return h('div', {}, err ? [h('small', {class: 'text-sm text-danger', attrs: {'data-path': this.model.$path + '.$error', id: this.id, role: 'alert'}}, this.checkErr)] : []);
    } else if (!this.model.$disabled) {
      return h('div', {}, err ? [h('small', {class: 'text-sm text-danger', attrs: {id: this.id, role: 'alert'}}, this.checkErr)] : []);
    } else {
      return h('div', {}, []);
    }
    /*

    const opts = {
      class: 'text-sm text-danger',
      domProps: {}
    };
    if (this.model.$form.generateId) {
      opts.domProps.id = this.model.$pathId + '_error';
    }
    if (this.model.$form.testPath) {
      opts.domProps['data-path'] = this.model.$path + '.$error';
    }
    return h('div', {}, err ? [h('small', opts, err)] : []);
    */

    /*

    if (this.model.$form.generateId) {
      return h('div', {}, err ? [h('small', {class: 'text-sm text-danger', domProps: {id: this.model.$pathId + '_error'}}, err)] : []);
    } else {
      return h('div', {}, err ? [h('small', {class: 'text-sm text-danger'}, err)] : []);
    }
    */
  },
  computed: {
    checkErr() {
      if (!this.model.$error || this.model.$error.toLowerCase().startsWith('błąd:')) {
        return this.model.$error;
      }
      return `Błąd: ${this.model.$error}`;
    }
  }
};
</script>
